import React, { createContext, useContext, useMemo, type PropsWithChildren } from 'react';
import type { KyInstance } from 'ky';
import { useZustandStore } from '../../../appState/StoresProvider';
import ky from 'ky';
import { useAuthStore } from '../../../components/Login/useAuthStore';

export function createRequestClientContext() {
  const RequestClientContext = createContext<KyInstance | undefined>(undefined);
  const RequestClientProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const tenantId = useZustandStore('auth', (v) => v.tenantId);
    const kyInstance = useMemo(
      () =>
        ky.extend({
          hooks: {
            beforeRequest: [
              (request) => {
                const store = useAuthStore.getState();

                if (store.loginStatus !== 'loggedIn') {
                  throw new Error('no auth available. this is unexpected');
                }

                request.headers.set('Authorization', `Bearer ${store.accessToken}`);
                if (tenantId) {
                  request.headers.set('OT-Customer-Id', tenantId);
                }
              },
            ],
          },
        }),
      [tenantId],
    );
    return <RequestClientContext.Provider value={kyInstance}>{children}</RequestClientContext.Provider>;
  };
  function useRequestClient() {
    const requestClient = useContext(RequestClientContext);
    // if (!requestClient) {
    //   throw new Error('Missing RequestClientProvider');
    // }
    return requestClient;
  }
  return { RequestClientProvider, useRequestClient };
}
